import { useMemo } from "react";
import usePaginatedApiData from "../../../../hooks/usePaginatedApiData";
import { buildPaginationParams, toCsvParam } from "../../../../utils/pagination";

const getProspectingCompanyItems = (responseData) => responseData?.data || [];
const getProspectingCompanyTotal = (responseData) => responseData?.total || 0;

export default function useProspectingCompaniesData({
  page,
  pageSize,
  searchTerm,
  filters,
  orderBy,
  orderDirection,
}) {
  const tagsParam = useMemo(() => toCsvParam(filters?.tags), [filters?.tags]);

  const params = useMemo(
    () => {
      return buildPaginationParams({
        page,
        pageSize,
        search: searchTerm || undefined,
        sector: filters?.sector || undefined,
        naics_name: filters?.naics_name || undefined,
        city: filters?.city || undefined,
        state: filters?.state || undefined,
        country: filters?.country || undefined,
        pipeline_stage: filters?.pipeline_stage || undefined,
        tags: tagsParam,
        order_by: orderBy,
        order_direction: orderDirection,
      });
    },
    [
      page,
      pageSize,
      searchTerm,
      filters?.sector,
      filters?.naics_name,
      filters?.city,
      filters?.state,
      filters?.country,
      filters?.pipeline_stage,
      tagsParam,
      orderBy,
      orderDirection,
    ],
  );

  const {
    data: companies,
    totalCount,
    loading,
    error,
    refetch,
    setData: setCompanies,
  } = usePaginatedApiData({
    endpoint: "/prospecting-companies/",
    params,
    errorMessage: "Failed to fetch prospecting companies",
    getItems: getProspectingCompanyItems,
    getTotal: getProspectingCompanyTotal,
  });

  return {
    companies,
    totalCount,
    loading,
    error,
    refetch,
    setCompanies,
  };
}
